import RencamSchedeMorteExportMdbList from "./pages/RencamSchedeMorteExportMdbList";

export default {
    RencamSchedeMorteExportMdbList,
};
